module.exports = __webpack_public_path__ + "img/selected-car-marker.3db1e1f5.png";